import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { kayitSmsYolla, kayitSmsDogrula, kayitHesapOlustur, sablonListesi } from '../services/api';

// 7 gün ücretsiz deneme — SMS doğrulamalı kendi kendine kayıt. 3 adım: telefon doğrulama,
// kod girişi, işletme bilgileri. Klinik projesindeki hasta randevu SMS doğrulama akışıyla
// aynı desen (Ahsu Telekom gateway + günlük tel/IP sınırlaması).
export default function YeniHesap() {
  const navigate = useNavigate();
  const [adim, setAdim] = useState(1); // 1: telefon, 2: kod, 3: işletme bilgileri

  const [telefon, setTelefon] = useState('');
  const [kod, setKod] = useState('');
  const [isletmeAdi, setIsletmeAdi] = useState('');
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');

  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const [sablonlar, setSablonlar] = useState([]);
  const [sablonId, setSablonId] = useState(null);
  const [sablonlarYuklendi, setSablonlarYuklendi] = useState(false);

  useEffect(() => {
    sablonListesi()
      .then((res) => {
        setSablonlar(res.data);
        if (res.data.length > 0) setSablonId(res.data[0].id); // varsayılan olarak ilk şablon seçili gelsin
      })
      .catch(() => {})
      .finally(() => setSablonlarYuklendi(true));
  }, []);

  const smsGonder = (e) => {
    e.preventDefault();
    setHata(''); setBilgi(''); setYukleniyor(true);
    kayitSmsYolla(telefon)
      .then((res) => { setBilgi(res.data.mesaj || 'Kod gönderildi.'); setAdim(2); })
      .catch((err) => setHata(err.response?.data?.hata || 'Kod gönderilemedi.'))
      .finally(() => setYukleniyor(false));
  };

  const koduDogrula = (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    kayitSmsDogrula(telefon, kod)
      .then(() => setAdim(3))
      .catch((err) => setHata(err.response?.data?.hata || 'Kod hatalı.'))
      .finally(() => setYukleniyor(false));
  };

  const hesabiOlustur = (e) => {
    e.preventDefault();
    if (!sablonId) { setHata('Lütfen bir şablon seçin.'); return; }
    setHata(''); setYukleniyor(true);
    kayitHesapOlustur({ telefon, kod, isletmeAdi, kullaniciAdi, sifre, sablonId })
      .then((res) => {
        localStorage.setItem('isletmeId', res.data.id);
        localStorage.setItem('isletmeAd', res.data.ad);
        localStorage.setItem('isletmeSlug', res.data.slug);
        localStorage.setItem('isletmeRol', 'MUDUR');
        navigate(`/${res.data.slug}`);
      })
      .catch((err) => setHata(err.response?.data?.hata || 'Hesap oluşturulamadı.'))
      .finally(() => setYukleniyor(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', padding: 20 }}>
      <div className="kart" style={{ width: adim === 3 ? 460 : 380 }}>
        <h2 style={{ marginTop: 0, color: '#1e2a3a' }}>7 Gün Ücretsiz Deneyin</h2>
        <p style={{ fontSize: 13, color: '#6b7684', marginTop: -8 }}>
          {adim === 1 && 'Cep telefonunuza gönderilecek kodla doğrulayarak başlayın.'}
          {adim === 2 && 'Telefonunuza gelen 4 haneli kodu girin.'}
          {adim === 3 && 'İşletmenizi tanımlayıp panelinize hemen geçin.'}
        </p>

        {hata && <div className="hata-kutu">{hata}</div>}
        {bilgi && adim === 2 && <div className="basari-kutu">{bilgi}</div>}

        {adim === 1 && (
          <form onSubmit={smsGonder}>
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Cep Telefonu</label>
              <input value={telefon} onChange={(e) => setTelefon(e.target.value)} placeholder="05XX XXX XX XX" required />
            </div>
            <button type="submit" disabled={yukleniyor} className="btn btn-vurgu" style={{ width: '100%' }}>
              {yukleniyor ? 'Gönderiliyor...' : 'Doğrulama Kodu Gönder'}
            </button>
          </form>
        )}

        {adim === 2 && (
          <form onSubmit={koduDogrula}>
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Doğrulama Kodu</label>
              <input value={kod} onChange={(e) => setKod(e.target.value)} maxLength={4} placeholder="0000" required />
            </div>
            <button type="submit" disabled={yukleniyor} className="btn btn-vurgu" style={{ width: '100%' }}>
              {yukleniyor ? 'Kontrol ediliyor...' : 'Kodu Doğrula'}
            </button>
          </form>
        )}

        {adim === 3 && (
          <form onSubmit={hesabiOlustur}>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>İşletme Adı</label>
              <input value={isletmeAdi} onChange={(e) => setIsletmeAdi(e.target.value)} placeholder="Örn: Oğuz Cafe" required />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
              <input value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} required />
            </div>
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
              <input type="password" value={sifre} onChange={(e) => setSifre(e.target.value)} required />
            </div>

            {sablonlarYuklendi && sablonlar.length > 0 && (
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 8 }}>
                  Faaliyet alanınıza en yakın şablonu seçin — menü, masa ve garson bilgisi hazır gelir <span style={{ color: '#c0392b' }}>(zorunlu)</span>
                </label>
                <select value={sablonId || ''} onChange={(e) => setSablonId(Number(e.target.value))} required>
                  {sablonlar.map((s) => (
                    <option key={s.id} value={s.id}>{s.ad}</option>
                  ))}
                </select>
              </div>
            )}

            {sablonlarYuklendi && sablonlar.length === 0 && (
              <div className="hata-kutu" style={{ marginBottom: 18 }}>
                Şu anda hiçbir örnek şablon tanımlanmamış, bu yüzden yeni hesap açılamıyor. Lütfen bizimle iletişime geçin.
              </div>
            )}

            <button
              type="submit"
              disabled={yukleniyor || (sablonlarYuklendi && sablonlar.length === 0)}
              className="btn btn-vurgu"
              style={{ width: '100%' }}
            >
              {yukleniyor ? 'Oluşturuluyor...' : 'Hesabımı Oluştur'}
            </button>
          </form>
        )}

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}>
          Zaten hesabınız var mı? <Link to={`${process.env.PUBLIC_URL}/giris`} style={{ color: '#e8600c', fontWeight: 700 }}>Giriş yapın</Link>
        </div>
      </div>
    </div>
  );
}
